import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { ActivationKeyMeta } from "@/types";

// Metadaten-Liste der Aktivierungsschluessel einer Lizenz (hash-frei). Sub-Resource
// der Lizenz.
export function useActivationKeys(licenseId: string | undefined): UseQueryResult<ActivationKeyMeta[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: licenseId
      ? queryKeys.subList("licenses", licenseId, "activation-keys")
      : ["resources", "licenses", "_invalid", "activation-keys", "list"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<ActivationKeyMeta[]>(`/licenses/${licenseId}/activation-keys`);
    },
    enabled: !!licenseId && !!session,
  });
}
